import classNames from "classnames";
import React, { forwardRef } from "react";
import FieldUtils from "../../utils/FieldUtils";

interface Props {
  icon?: string;
  text: string | React.ReactNode;
  css?: string;
  onClick?: () => void;
  rightIcon: string;
  open: boolean;
  border?: boolean;
  options?: React.ReactNode;
  image?: string;
}

const baseSidebarLinkCss =
  "tw:text-[13px] tw:transition tw:delay-50 tw:duration-300 tw:ease-in-out tw:font-bold tw:text-dark tw:cursor-pointer tw:rounded-md tw:block tw:px-3 tw:py-2 tw:no-underline";

const SidebarSwitcher = forwardRef<HTMLDivElement, Props>(
  (
    {
      icon,
      text,
      css = "",
      onClick,
      rightIcon,
      open,
      border = true,
      options,
      image,
    },
    ref
  ) => {
    const Switcher = (
      <div
        ref={ref}
        className={classNames(
          `${baseSidebarLinkCss} tw:mb-2 tw:flex tw:items-center`,
          {
            border: open ? true : border,
            "tw:justify-between tw:px-2": open,
            "tw:justify-center": !open,
            [css]: true,
          }
        )}
        style={{
          height: 34,
          fontSize: 13,
          margin: open ? undefined : "",
        }}
        onClick={onClick}
      >
        <div
          className="tw:flex tw:items-center"
          style={{ width: open ? `calc(100% - 30px)` : undefined }}
        >
          {image ? (
            <img
              className="m-1"
              style={{
                width: 20,
                height: 20,
                borderRadius: 2,
                border: "1px solid var(--superlight)",
              }}
              src={image}
              alt="cloud-app-icon"
            />
          ) : (
            <>
              {icon ? (
                <i
                  className={icon}
                  style={{
                    fontSize: !open && !border ? 24 : 18,
                    width: open ? 22 : undefined,
                  }}
                />
              ) : (
                <div
                  className="tw:text-white tw:bg-primary tw:rounded-sm tw:flex tw:justify-center tw:items-center tw:text-xs"
                  style={{
                    height: 22,
                    width: 22,
                  }}
                >
                  {FieldUtils.getInitials({
                    _RecordName: text || "App",
                  })}
                </div>
              )}
            </>
          )}
          {open && <div className="text-truncate ml-2">{text}</div>}
        </div>
        {open && (
          <i
            className={`${rightIcon} tw:cursor-pointer tw:rounded-sm`}
            style={{ fontSize: 24, lineHeight: 1 }}
          />
        )}
      </div>
    );

    if (!options) return Switcher;

    return (
      <div className="tw:flex tw:w-full tw:justify-between tw:items-center">
        {Switcher}
      </div>
    );
  }
);

export default SidebarSwitcher;
